import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

export function Button({
  variant = 'primary',
  size = 'md',
  type = 'button',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = "rounded-lg font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2";

  const variants = {
    primary: "bg-[--clinqr-primary] text-white hover:brightness-150 hover:scale-[1.02] active:brightness-95 active:scale-100 shadow-sm",
    secondary: "border-2 border-[--clinqr-primary] text-[--clinqr-primary] bg-transparent hover:bg-gray-200 hover:scale-[1.02] active:bg-gray-300 active:scale-100",
    ghost: "text-[--clinqr-primary] bg-transparent hover:bg-gray-200 active:bg-gray-300",
    danger: "bg-[--clinqr-error] text-white hover:brightness-125 hover:scale-[1.02] active:brightness-95 active:scale-100 shadow-sm"
  };

  const sizes = {
    sm: 'h-8 px-3 text-sm',
    md: 'h-10 px-6',
    lg: 'h-12 px-8',
  };

  return (
    <button
      type={type}
      className={`${baseStyles} ${sizes[size]} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
